import type { HiddenSettings } from "@/types/homey";

/**
 * Defensive parse of the dashboard_settings.hidden jsonb blob into a fully
 * typed HiddenSettings. Tolerates null, undefined, non-objects, arrays, and
 * garbage values. Keeps only non-empty string device ids, deduplicated with
 * first-seen order preserved. Always returns a fresh array.
 */
export function normalizeHiddenSettings(raw: unknown): HiddenSettings {
  if (raw === null || raw === undefined || typeof raw !== "object" || Array.isArray(raw)) {
    return { deviceIds: [] };
  }

  const obj = raw as Record<string, unknown>;
  if (!Array.isArray(obj.deviceIds)) {
    return { deviceIds: [] };
  }

  const seen = new Set<string>();
  const deviceIds: string[] = [];
  for (const value of obj.deviceIds) {
    if (typeof value !== "string" || value.length === 0) continue;
    if (seen.has(value)) continue;
    seen.add(value);
    deviceIds.push(value);
  }

  return { deviceIds };
}
